/* Imports */
import React, { useState } from "react"
import { InputImage } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const InputImagePage = () => {
    const [image, setImage] = useState("")

    const handleImage = e => {
        if (e.target.files[0]) {
            setImage(e.target.files[0])
            const reader = new FileReader()
            reader.addEventListener("load", () => {
                setImage(reader.result)
            })
            reader.readAsDataURL(e.target.files[0])
        }
    }

    const items = [
        {
            content: (
                <InputImage
                    id="image"
                    src={image}
                    onChange={e => handleImage(e)}
                    label="Input image"
                    fajnyIconEmpty="user-solid"
                />
            ),
            code: 'const [image, setImage] = useState("")\n\nconst handleImage = e => {\n    if (e.target.files[0]) {\n        setImage(e.target.files[0])\n        const reader = new FileReader()\n        reader.addEventListener("load", () => {\n            setImage(reader.result)\n        })\n        reader.readAsDataURL(e.target.files[0])\n    }\n}\n\n<InputImage\n    id="image"\n    src={image}\n    onChange={e => handleImage(e)}\n    label="Input image"\n    fajnyIconEmpty="user-solid"\n/>',
        },
    ]

    const propsItems = [
        {
            name: "id",
            type: "String",
            example: "input",
            required: "Yes",
        },
        {
            name: "src",
            type: "String",
            example: "/images/picture.jpg",
            required: "Yes",
        },
        {
            name: "alt",
            type: "String",
            example: "Picture",
            default: "Image",
        },
        {
            name: "label",
            type: "String",
            example: "Upload your avatar",
        },
        {
            name: "helper",
            type: "String",
            example: "Your image can not be larger than 5 MB",
        },
        {
            name: "helperBottom",
            type: "String",
            example: "Your image can not be larger than 5 MB",
        },
        {
            name: "iconEmpty",
            type: "String",
            example: "user",
        },
        {
            name: "iconHover",
            type: "String",
            example: "edit",
        },
        {
            name: "fajnyIconEmpty",
            type: "String",
            example: "user-regular",
            possible: commonProps.fajnyIcons,
            default: "image-solid",
        },
        {
            name: "fajnyIconHover",
            type: "String",
            example: "edit-regular",
            possible: commonProps.fajnyIcons,
            default: "edit-solid",
        },
        {
            name: "validation",
            type: "String",
            example: "not-passed",
            possible: commonProps.validationInput,
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default InputImagePage
